import { Injectable } from '@angular/core';

export interface ToastMessage {
  text: string;
  type: 'success' | 'danger' | 'warning' | 'info';
  title: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: ToastMessage[] = [];

  // Método para disparar una alerta de error (Bloqueos)
  showDanger(title: string, text: string) {
    this.show({ title, text, type: 'danger' });
  }

  // Método para disparar una alerta de éxito (Guardados exitosos)
  showSuccess(title: string, text: string) {
    this.show({ title, text, type: 'success' });
  }

  private show(toast: ToastMessage) {
    this.toasts.push(toast);
    
    // Auto-elimina la alerta después de 5 segundos para que no sature la pantalla
    setTimeout(() => {
      this.remove(toast);
    }, 5000);
  }

  remove(toast: ToastMessage) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}